import { jsxs as s, jsx as e } from "react/jsx-runtime";
const t = (l) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: [
      /* @__PURE__ */ e(
        "mask",
        {
          id: "google-sheets_svg__a",
          width: 18,
          height: 24,
          x: 3,
          y: 0,
          maskUnits: "userSpaceOnUse",
          style: {
            maskType: "luminance"
          },
          children: /* @__PURE__ */ e(
            "path",
            {
              fill: "#fff",
              d: "M14.12.343H5.112c-.874 0-1.59.716-1.59 1.59v20.134c0 .874.716 1.59 1.59 1.59h13.776c.874 0 1.59-.716 1.59-1.59V6.701z"
            }
          )
        }
      ),
      /* @__PURE__ */ e("g", { mask: "url(#google-sheets_svg__a)", children: /* @__PURE__ */ e(
        "path",
        {
          fill: "#0F9D58",
          d: "M14.12.343H5.112c-.874 0-1.59.716-1.59 1.59v20.134c0 .874.716 1.59 1.59 1.59h13.776c.874 0 1.59-.716 1.59-1.59V6.701l-3.71-2.649z"
        }
      ) }),
      /* @__PURE__ */ e(
        "mask",
        {
          id: "google-sheets_svg__b",
          width: 18,
          height: 24,
          x: 3,
          y: 0,
          maskUnits: "userSpaceOnUse",
          style: {
            maskType: "luminance"
          },
          children: /* @__PURE__ */ e(
            "path",
            {
              fill: "#fff",
              d: "M14.12.343H5.112c-.874 0-1.59.716-1.59 1.59v20.134c0 .874.716 1.59 1.59 1.59h13.776c.874 0 1.59-.716 1.59-1.59V6.701z"
            }
          )
        }
      ),
      /* @__PURE__ */ e("g", { mask: "url(#google-sheets_svg__b)", children: /* @__PURE__ */ e(
        "path",
        {
          fill: "#F1F1F1",
          d: "M7.761 11.735v7.683h8.478v-7.683zm3.71 6.623H8.82v-1.324h2.65zm0-2.12H8.82v-1.324h2.65zm0-2.119H8.82v-1.324h2.65zm3.708 4.24h-2.65v-1.325h2.65zm0-2.12h-2.65v-1.325h2.65zm0-2.12h-2.65v-1.324h2.65z"
        }
      ) }),
      /* @__PURE__ */ e(
        "mask",
        {
          id: "google-sheets_svg__c",
          width: 18,
          height: 24,
          x: 3,
          y: 0,
          maskUnits: "userSpaceOnUse",
          style: {
            maskType: "luminance"
          },
          children: /* @__PURE__ */ e(
            "path",
            {
              fill: "#fff",
              d: "M14.12.343H5.112c-.874 0-1.59.716-1.59 1.59v20.134c0 .874.716 1.59 1.59 1.59h13.776c.874 0 1.59-.716 1.59-1.59V6.701z"
            }
          )
        }
      ),
      /* @__PURE__ */ e("g", { mask: "url(#google-sheets_svg__c)", children: /* @__PURE__ */ e(
        "path",
        {
          fill: "url(#google-sheets_svg__d)",
          d: "m14.585 6.237 5.893 5.892V6.702z"
        }
      ) }),
      /* @__PURE__ */ e(
        "mask",
        {
          id: "google-sheets_svg__e",
          width: 18,
          height: 24,
          x: 3,
          y: 0,
          maskUnits: "userSpaceOnUse",
          style: {
            maskType: "luminance"
          },
          children: /* @__PURE__ */ e(
            "path",
            {
              fill: "#fff",
              d: "M14.12.343H5.112c-.874 0-1.59.716-1.59 1.59v20.134c0 .874.716 1.59 1.59 1.59h13.776c.874 0 1.59-.716 1.59-1.59V6.701z"
            }
          )
        }
      ),
      /* @__PURE__ */ e("g", { mask: "url(#google-sheets_svg__e)", children: /* @__PURE__ */ e(
        "path",
        {
          fill: "#87CEAC",
          d: "M14.12.343v4.769c0 .878.711 1.59 1.59 1.59h4.768z"
        }
      ) }),
      /* @__PURE__ */ e(
        "mask",
        {
          id: "google-sheets_svg__f",
          width: 18,
          height: 24,
          x: 3,
          y: 0,
          maskUnits: "userSpaceOnUse",
          style: {
            maskType: "luminance"
          },
          children: /* @__PURE__ */ e(
            "path",
            {
              fill: "#fff",
              d: "M14.12.343H5.112c-.874 0-1.59.716-1.59 1.59v20.134c0 .874.716 1.59 1.59 1.59h13.776c.874 0 1.59-.716 1.59-1.59V6.701z"
            }
          )
        }
      ),
      /* @__PURE__ */ e("g", { mask: "url(#google-sheets_svg__f)", children: /* @__PURE__ */ e(
        "path",
        {
          fill: "#fff",
          fillOpacity: 0.2,
          d: "M5.112.343c-.874 0-1.59.716-1.59 1.59v.132c0-.874.716-1.59 1.59-1.59h9.008V.344z"
        }
      ) }),
      /* @__PURE__ */ e(
        "mask",
        {
          id: "google-sheets_svg__g",
          width: 18,
          height: 24,
          x: 3,
          y: 0,
          maskUnits: "userSpaceOnUse",
          style: {
            maskType: "luminance"
          },
          children: /* @__PURE__ */ e(
            "path",
            {
              fill: "#fff",
              d: "M14.12.343H5.112c-.874 0-1.59.716-1.59 1.59v20.134c0 .874.716 1.59 1.59 1.59h13.776c.874 0 1.59-.716 1.59-1.59V6.701z"
            }
          )
        }
      ),
      /* @__PURE__ */ e("g", { mask: "url(#google-sheets_svg__g)", children: /* @__PURE__ */ e(
        "path",
        {
          fill: "#263238",
          fillOpacity: 0.2,
          d: "M18.888 23.524H5.112c-.874 0-1.59-.715-1.59-1.59v.133c0 .874.716 1.59 1.59 1.59h13.776c.874 0 1.59-.716 1.59-1.59v-.132c0 .874-.716 1.59-1.59 1.59"
        }
      ) }),
      /* @__PURE__ */ e(
        "mask",
        {
          id: "google-sheets_svg__h",
          width: 18,
          height: 24,
          x: 3,
          y: 0,
          maskUnits: "userSpaceOnUse",
          style: {
            maskType: "luminance"
          },
          children: /* @__PURE__ */ e(
            "path",
            {
              fill: "#fff",
              d: "M14.12.343H5.112c-.874 0-1.59.716-1.59 1.59v20.134c0 .874.716 1.59 1.59 1.59h13.776c.874 0 1.59-.716 1.59-1.59V6.701z"
            }
          )
        }
      ),
      /* @__PURE__ */ e("g", { mask: "url(#google-sheets_svg__h)", children: /* @__PURE__ */ e(
        "path",
        {
          fill: "#263238",
          fillOpacity: 0.1,
          d: "M15.71 6.701a1.59 1.59 0 0 1-1.59-1.59v.133c0 .879.711 1.59 1.59 1.59h4.768V6.7z"
        }
      ) }),
      /* @__PURE__ */ e(
        "path",
        {
          fill: "url(#google-sheets_svg__i)",
          d: "M14.12.343H5.112c-.874 0-1.59.716-1.59 1.59v20.134c0 .874.716 1.59 1.59 1.59h13.776c.874 0 1.59-.716 1.59-1.59V6.701z"
        }
      ),
      /* @__PURE__ */ s("defs", { children: [
        /* @__PURE__ */ s(
          "radialGradient",
          {
            id: "google-sheets_svg__i",
            cx: 0,
            cy: 0,
            r: 1,
            gradientTransform: "matrix(2734 0 0 2734.01 57.237 46.42)",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ e("stop", { stopColor: "#fff", stopOpacity: 0.1 }),
              /* @__PURE__ */ e("stop", { offset: 1, stopColor: "#fff", stopOpacity: 0 })
            ]
          }
        ),
        /* @__PURE__ */ s(
          "linearGradient",
          {
            id: "google-sheets_svg__d",
            x1: 309.28,
            x2: 309.28,
            y1: 56.825,
            y2: 595.513,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ e("stop", { stopColor: "#263238", stopOpacity: 0.2 }),
              /* @__PURE__ */ e("stop", { offset: 1, stopColor: "#263238", stopOpacity: 0.02 })
            ]
          }
        )
      ] })
    ]
  }
);
export {
  t as default
};
